export enum ADMIN_EVENT {
  FETCH_RESPONSE = 'fetchResponse',
  EVENT_LOG = 'eventLog'
}
